import Chip from './Chip.vue'

export default Chip
